define('components/handlers/kyc-report/download-kyc-report',[
    'jquery',
], function($) {
    $.extend(companyInfo.handlers, {
        'download-kyc-report': function() {
            var clickedButton = $(this);
            var dossierID = $('input[name="dossier-id"]').first().val();
            var spinner = $( "#download-spinner" );

            // Hide the button text and show a spinner
            clickedButton.addClass('hidden');
            clickedButton.removeClass('submit');
            spinner.removeClass('hidden');
            fetch('/kyc/reports/' + dossierID + '/pdf').then(function(res, rej) {
                if (res.ok) {
                    var cd = res.headers.get('Content-Disposition');
                    var fileName = cd ? cd.match(/filename=\"(.+)\"/)[1] : 'document.pdf';
                    res.blob().then(function(blob) {
                        var url = window.URL.createObjectURL(blob);
                        var a = document.createElement('a');
                        a.style.display = 'none';
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                        a.remove();
                    });
                }
            }).finally(function() {
                spinner.addClass('hidden');
                clickedButton.addClass('submit');
                clickedButton.removeClass('hidden');
            });
        },
    });
});

